// CriticalApplications.js
import React from 'react';
import img from '../img/3d_render_design.avif';
import img2 from '../img/3d_visualization.avif';
import img3 from '../img/bathroom_top.avif';
const CriticalApplications = () => {
  const sectionContainerStyle = {
    backgroundColor: '#fff',
    padding: '32px',
    borderRadius: '12px',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)', // Slightly stronger shadow
    width: '100%',
    maxWidth: '1024px', // Increased max-width
    margin: '40px auto', // Increased margin for spacing
    fontFamily: "'Hind', sans-serif", // Using an Indian-origin font
    color: '#2C3E50', // Darker text for better readability
  };

  const sectionTitleStyle = {
    fontSize: '2.5rem', // Slightly larger title
    fontWeight: '700', // Bolder title
    color: '#0A3D62', // Deep blue for title
    marginBottom: '28px',
    textAlign: 'center',
  };

  const sectionDescriptionStyle = {
    color: '#536878', // Softer grey for description
    marginBottom: '40px', // Increased margin for better separation
    textAlign: 'center',
    maxWidth: '800px',
    margin: '0 auto 40px auto',
    lineHeight: '1.7', // Improved line height
  };

  const gridContainerStyle = {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', // Responsive grid, slightly wider min-width
    gap: '36px', // Increased gap
  };

  const expertiseCardStyle = {
    backgroundColor: '#F7F9FA', // Lighter background for cards
    borderRadius: '10px',
    padding: '28px', // Increased padding
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.08)', // Subtle shadow for cards
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    transition: 'transform 0.3s ease-in-out', // Added transition for hover effect
    '&:hover': {
      transform: 'translateY(-5px)', // Lift card on hover
    },
  };

  const subTitleStyle = {
    fontWeight: '600',
    fontSize: '1.65rem', // Slightly larger title for cards
    marginBottom: '16px',
    color: '#1C6EA4', // A shade of blue for card titles
  };

  const cardDescriptionStyle = {
    color: '#536878',
    lineHeight: '1.7',
    marginBottom: '20px', // Space between description and image
  };

  const imageStyle = {
    width: '100%',
    height: '200px', // Fixed height for images
    objectFit: 'cover', // Ensures images cover the area without distortion
    borderRadius: '8px',
    marginBottom: '20px', // Space between image and text
  };

  return (
    <section style={sectionContainerStyle}>
      <h2 style={sectionTitleStyle}>Key Sectors & Our Surveying Prowess in India</h2>
      <p style={sectionDescriptionStyle}>
        Our surveying expertise is indispensable across India's rapidly developing sectors, ensuring precision and legal adherence for critical projects. We employ advanced technology and deep local insights to deliver exceptional results, providing the foundational geospatial data vital for informed decision-making and seamless project execution.
      </p>
      <div style={gridContainerStyle}>
        {/* Infrastructure & Construction */}
        <div style={expertiseCardStyle}>
          <img
            src={img3}// Greenish tone for infrastructure
            alt="Infrastructure and Construction Surveying in India"
            style={imageStyle}
          />
          <h3 style={subTitleStyle}>Infrastructure & Construction</h3>
          <p style={cardDescriptionStyle}>
            Accurate land surveying is the bedrock of India's ambitious infrastructure and construction projects, including those under **PM Gati Shakti** and major highway developments. We provide precise **topographic surveys**, detailed **DGPS/ETS surveys**, and **boundary demarcations** crucial for roads, bridges, smart cities, and industrial corridors. Our work minimizes project delays and ensures structural integrity, aligning with India's rapid development goals.
          </p>
        </div>

        {/* Land Development & Urban Planning */}
        <div style={expertiseCardStyle}>
          <img
            src={img2} // Blueish tone for urban planning
            alt="Land Development and Urban Planning Surveying in India"
            style={imageStyle}
          />
          <h3 style={subTitleStyle}>Land Development & Urban Planning</h3>
          <p style={cardDescriptionStyle}>
            For India's evolving urban and rural landscapes, our **subdivision planning**, **cadastral surveys**, and **easement mapping** are vital. We deliver the granular data required for zoning compliance, property valuation, and the strategic expansion of metropolitan areas and emerging towns under initiatives like the **Smart Cities Mission**. This ensures sustainable growth and optimized land utilization.
          </p>
        </div>

        {/* Property Rights & Land Records Modernization */}
        <div style={expertiseCardStyle}>
          <img
            src={img} // Reddish tone for legal/property
            alt="Property Rights and Land Records Modernization Surveying in India"
            style={imageStyle}
          />
          <h3 style={subTitleStyle}>Property Rights & Land Records Modernization</h3>
          <p style={cardDescriptionStyle}>
            Safeguard your land assets with our definitive **property boundary surveys**, essential for resolving land disputes and ensuring clear ownership. We assist in **land record modernization efforts** (e.g., *Digital India Land Records Modernization Programme* - DILRMP), identify encroachments, and prepare legal documentation, providing irrefutable evidence for property transactions and secure land titles across India.
          </p>
        </div>
      </div>
    </section>
  );
};

export default CriticalApplications;